import { observer } from 'mobx-react';
import { FC } from 'react';
import store from 'modules/Transfer/store';
import classlist from 'utils/classlist';
import style from './style.scss';

interface ProgressBarProps {
    className?: string;
}

const ProgressBar: FC<ProgressBarProps> = observer(({ className }) => {
    if (!store.showProgressBar) {
        return null;
    }

    return (
        <div className={classlist(style.root, className)}>
            <div className={style.bg}>
                <div className={style.bar} style={{ width: `${(store.step / store.maxStep) * 100}%` }}></div>
            </div>
            <div className={style.label}>
                <span className={style.current}>{store.step}</span>
                <span>/{store.maxStep}</span>
            </div>
        </div>
    );
});

export default ProgressBar;
